import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { getKeycloakUidFromToken } from '@/utils/keycloakUidForSupabase';
import { toast } from 'sonner';

interface CSATSubmitData {
  page_id: string;
  page_name: string;
  page_path: string;
  rating: number;
  comment?: string;
}

export const useCSATSubmit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CSATSubmitData) => {
      const userId = await getKeycloakUidFromToken();

      const { data: userData, error: userError } = await supabase
        .from('users')
        .select('generator_id')
        .eq('auth_id', userId)
        .maybeSingle();

      if (userError) throw userError;

      const { data: response, error } = await supabase
        .from('csat_responses')
        .insert({
          user_id: userId,
          generator_id: userData?.generator_id || null,
          page_id: data.page_id,
          page_name: data.page_name,
          page_path: data.page_path,
          rating: data.rating,
          comment: data.comment || null,
        })
        .select()
        .single();

      if (error) throw error;
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['csat-responses'] });
      toast.success('Obrigado pelo seu feedback!');
    },
    onError: (error) => {
      console.error('Erro ao enviar feedback CSAT:', error);
      toast.error('Erro ao enviar feedback. Tente novamente.');
    },
  });
};
